<script setup lang="ts">
    import { onMounted, ref, inject, computed } from 'vue';
    import axios from 'axios';
    import AdminCredentialsInfosModal from './AdminCredentialsInfosModal.vue';
    import ConfirmationModal from '@/components/ConfirmationModal.vue';
    import { formatDate } from '../../utils';
    
    const BACKEND_URL = inject('BACKEND_URL');
    const errorMessage = ref('');
    const loading = ref(false);
    const itemsList = ref([] as any[]);
    const credentialsInfosModalRef = ref<InstanceType<typeof AdminCredentialsInfosModal> | null>(null);
    const confirmationModalRef = ref<InstanceType<typeof ConfirmationModal> | null>(null);
    const selectedItems = ref([] as any[]);
    const areAllItemsSelected = computed(() => {
        return itemsList.value.length == selectedItems.value.length;
    });

    onMounted(() => {
        doListAdminsAction();
    });

    async function doListAdminsAction() {
        try {
            loading.value = true;
            errorMessage.value = '';
            const httpResponse = await axios.get(`/backoffice/admins/list`);
            itemsList.value = httpResponse.data;
        } catch(error: any) {
            errorMessage.value = error.message;
        } finally {
            loading.value = false;
        }
    }

    function openCredentialsModal(item: any) {
        credentialsInfosModalRef?.value?.open(item);
    }

    async function doDeleteAdminAction(item: any) {
        const confirmation = await confirmationModalRef.value?.open("Administrateurs", "Voulez-vous vraiment supprimer cet administrateur ?");
        if (confirmation) {
            try {
                loading.value = true;
                errorMessage.value = '';
                await axios.post(`/backoffice/admins/destroy/${item.id}`, {});
                const index = itemsList.value.findIndex(i => i.id == item.id);
                if (index > -1) {
                    const itemsListCloned = itemsList.value;
                    itemsListCloned.splice(index, 1);
                    itemsList.value = itemsListCloned;
                }
            } catch(error: any) {
                errorMessage.value = error.message;
            } finally {
                loading.value = false;
            }
        }
    }

    async function doToggleEtatValideAction(itemsIds: any[]) {
        const confirmation = await confirmationModalRef.value?.open("Administrateurs", "Voulez-vous vraiment modifier l'état des éléments sélectionnés ?");
        if (confirmation) {
            try {
                loading.value = true;
                errorMessage.value = '';
                await axios.post(`/backoffice/admins/toggle_etat_valide`, { ids: itemsIds });

                itemsIds.forEach(itemId => {
                    const index = itemsList.value.findIndex(i => i.id == itemId);
                    if (index > -1) {
                        itemsList.value[index].etat_valide = itemsList.value[index].etat_valide == 1 ? 0 : 1;
                    }
                });

            } catch(error: any) {
                errorMessage.value = error.message;
            } finally {
                loading.value = false;
            }
        }
    }

    function handleCheckAll(_event: any) {
        const checked = _event.target.checked;
        if (checked) {
            selectedItems.value = itemsList.value.map(i => i.id);
        } else {
            selectedItems.value = [];
        }
    }
</script>

<template>
  <section class="container-full-app bg-grey-50">
    <div class="page-space-30"></div>

    <!--*** Widget *** -->
    <section class="s20">
        <div class="widget shadow-100 pb-2"><!-- widget shadow-100 fill -->
            <!--Card-->
            <div>
                <div class="container-full-2 my-5">
                    <div class="s7"><h4 class="font-semibold mt-4">Administrateurs <span class="text-sm text-grey-500">({{ itemsList.length }})</span></h4></div>
                    <div class="s13 flex justify-content-right">
                        <router-link id="btn-add" to="/app/admins/form" class="flex-center">
                            <button class="btn normal ml-4 justify-content-center btn-filtre">
                                <img src="/icons/icon-add.svg" class="btn-icon" alt="" />
                                <span>Créer</span>
                            </button>
                        </router-link>
                        <div class="form-field-floating default sm s4_mobile ml-3">
                            <select class="form-input-select" name="pays" id="pays">
                                <option value="">Trier</option>
                                <option value="" selected>Ordre Décroissant</option>
                                <option value="">Ordre Croissant</option>
                                <option value="">De A - Z</option>
                                <option value="">De Z - A</option>
                            </select>
                        </div>
                        <button class="btn normal white2 s3_mobile ml-4 justify-content-center btn-filtre btn-filter">
                            <img src="/icons/icon-filter.svg" class="btn-icon" alt="" />
                            <span>Options</span>
                        </button>
                    </div>
                    <div class="clear-both"></div>
                    <!--Options-->
                    <div class="filter-set-area">
                        <div class="grid-filter6 mt-4 mb-0">
                            <div class="form-field-floating reactive sm">
                                <input type="date" class="form-input" name="date1" id="date1" placeholder="">
                                <label for="date1">Date de création &lt;=</label>
                            </div>
                            <div class="form-field-floating reactive sm">
                                <input type="date" class="form-input" name="date2" id="date2" placeholder="">
                                <label for="date2">Date de création >=</label>
                            </div>
                            <div class="form-field-floating sm">
                                <select class="form-input-select" name="pays" id="pays">
                                    <option value="" selected>Tout les etats</option>
                                    <option value="">Actif</option>
                                    <option value="">Inactif</option>
                                </select>
                                <label for="pays">Etat <b class="color-danger">*</b></label>
                            </div>
                            <div class="form-field-floating sm">
                                <select class="form-input-select" name="pays" id="pays">
                                    <option value="" selected>Tout les etats</option>
                                    <option value="">Actif</option>
                                    <option value="">Inactif</option>
                                </select>
                                <label for="pays">Etat <b class="color-danger">*</b></label>
                            </div>
                            <button class="btn black normal justify-content-center mx-0 btn-filtre">
                                <img src="/icons/icon-excel.svg" class="btn-icon" alt="" />
                                <span>Exporter Excel</span>
                            </button>
                            <button class="btn black normal justify-content-center mx-0 btn-filtre">
                                <img src="/icons/icon-pdf.svg" class="btn-icon" alt="" />
                                <span>Exporter PDF</span>
                            </button>
                        </div>
                    </div>
                    <!---->
                </div>
                <hr class="s20 my-0 hr2 opacity-1"/>
                <table class="table separator skin2 selection"><!-- selection skin1 skin2 (bg1 bg2 bg3)  (skin3 rounded)  -->
                    <thead>
                        <tr>
                            <th>
                                <label class="btn-circle" for="check_all">
                                    <input type="checkbox" id="check_all" :checked="areAllItemsSelected" @change="handleCheckAll" />
                                </label>
                            </th>
                            <th></th>
                            <th><img src="/icons/icon-filter-up.svg" class="size-xxs mt--1" alt="" /> Nom d'utilisateur</th>
                            <th><img src="/icons/icon-filter-up.svg" class="size-xxs mt--1" alt="" /> Role</th>
                            <th><img src="/icons/icon-filter-up.svg" class="size-xxs mt--1" alt="" /> Date création</th>
                            <th><img src="/icons/icon-filter-none.svg" class="size-xxs mt--1" alt="" /> Dernière connexion</th>
                            <th class="flex-right" v-show="false">
                                <button class="btn-ultra white2 tips display-none"><!-- loading sm tips color2 light white white2 success info warning danger-->
                                    <div class="btn-show">
                                        <img src="/icons/icon-destroy.svg" class="btn-icon icon-neutral" alt="" />
                                        <span>Détruire</span>
                                    </div>
                                    <div class="btn-loading">
                                        <div class="loader-dots"></div>
                                    </div>
                                </button>
                                <button class="btn-ultra white2 tips"><!--loading-->
                                    <div class="btn-show">
                                        <img src="/icons/icon-delete.svg" class="btn-icon" alt="" />
                                        <span>Supprimer</span>
                                    </div>
                                    <div class="btn-loading">
                                        <div class="loader-dots"></div>
                                    </div>
                                </button>
                                <button class="btn-ultra white2 tips"><!--loading-->
                                    <div class="btn-show">
                                        <img src="/icons/icon-restaurer.svg" class="btn-icon icon-neutral" alt="" />
                                        <span>Restaurer</span>
                                    </div>
                                    <div class="btn-loading">
                                        <div class="loader-dots"></div>
                                    </div>
                                </button>
                                <button class="btn-ultra color2 tips">
                                    <div class="btn-show">
                                        <img src="/icons/icon-actif.svg" class="btn-icon" alt="" />
                                        <span>Actif</span>
                                    </div>
                                    <div class="btn-loading">
                                        <div class="loader-dots"></div>
                                    </div>
                                </button>
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        <template v-if="itemsList.length == 0">
                            <tr>
                                <td colspan="7">
                                    <div class="text-center text-grey-700">Aucun élément trouvé</div>
                                </td>
                            </tr>
                        </template>
                        <tr class="text-grey-700 over-effect" v-for="(item, index) in itemsList" :key="'admin_' + index"><!-- over-effect active-->
                            <td class="selection-item">
                                <label class="btn-circle" :for="'item_check_' + index">
                                    <input type="checkbox" name="selectedItems[]" :id="'item_check_' + index" :value="item.id" v-model="selectedItems" />
                                </label>
                            </td>
                            <td class="flex">
                                <div class="square-xl rounded-15" style="background-color: rgb(var(--color-warning-rgb), 0.2);"><img :src="!!item.photo_url ? item.photo_url : ('/assets/users/300w/' + item.avatar)" width="100%" /></div>
                                <div class="square-xl rounded-15 ml-3 px-3 py-3" style="background-color: rgb(var(--color-warning-rgb), 0.2);"><img src="/icons/icon-menu-securite.svg" width="100%" /></div>
                            </td>
                            <td><h5 class="mb-1 font-semibold">{{ item.username }}</h5> <span class="text-sm text-grey-500">{{ (item.nom ?? '') + ' ' + (item.prenom ?? '') }}</span></td>
                            <td><p class="mb-2 color-info">{{ item.role ? item.role.libelle : '-' }}</p> <span class="text-sm text-grey-500"><img src="/icons/icon-menu-securite.svg" class="size-xxs" /> {{ item.role ? item.role.codes_permissions.length : '-' }} Permissions</span></td>
                            <td><b class="text-sm text-grey-500">{{ formatDate(item.created_at) }}</b></td>
                            <td><b class="text-sm text-grey-500">{{ item.last_connection_at ? formatDate(item.last_connection_at) : '' }}</b></td>
                            <td class="flex-right">
                                <button class="btn-ultra white2 tips display-none"><!-- loading sm tips color2 light white white2 success info warning danger-->
                                    <div class="btn-show">
                                        <img src="/icons/icon-destroy.svg" class="btn-icon icon-neutral" alt="" />
                                        <span>Détruire</span>
                                    </div>
                                    <div class="btn-loading display-none">
                                        <div class="loader-dots"></div>
                                    </div>
                                </button>
                                <custom-button :classesList="'btn-ultra white2 tips'" :id="'btn-delete-' + item.id" @click="doDeleteAdminAction(item)">
                                    <img src="/icons/icon-delete.svg" class="btn-icon" alt="" />
                                    <span>Supprimer</span>
                                </custom-button>
                                <button class="btn-ultra white2 tips display-none"><!--loading-->
                                    <div class="btn-show">
                                        <img src="/icons/icon-restaurer.svg" class="btn-icon icon-neutral" alt="" />
                                        <span>Restaurer</span>
                                    </div>
                                    <div class="btn-loading">
                                        <div class="loader-dots"></div>
                                    </div>
                                </button>
                                <custom-button :classesList="'btn-ultra white2 tips'" @click="openCredentialsModal(item)">
                                    <img src="/icons/icon-menu-securite.svg" class="btn-icon icon-neutral" alt="" />
                                        <span>Informations de connexion</span>
                                </custom-button>
                                <custom-button :classesList="'btn-ultra color2 tips'" @click="doToggleEtatValideAction([item.id])"  v-if="item.etat_valide == 1">
                                    <img src="/icons/icon-actif.svg" class="btn-icon" alt="" />
                                    <span>Actif</span>
                                </custom-button>
                                <custom-button :classesList="'btn-ultra color2 tips'" @click="doToggleEtatValideAction([item.id])" v-if="item.etat_valide == 0">
                                    <img src="/icons/icon-inactif.svg" class="btn-icon" alt="" />
                                    <span>Inactif</span>
                                </custom-button>
                                <router-link :to="'/app/admins/form/' + item.id">
                                    <custom-button :classesList="'btn'" :id="'btn-edit-' + item.id">
                                        <img src="/icons/icon-edit.svg" class="btn-icon" alt="" />
                                        <span>Editer</span>
                                    </custom-button>
                                </router-link>
                                <custom-button :classesList="'btn white2 collapse-open-table'">
                                    <img src="/icons/icon-list.svg" class="btn-icon" alt="" />
                                    <span>Plus</span>
                                </custom-button>
                            </td>
                        </tr>
                        <tr class="bg-white">
                            <td colspan="7" class="collapse-content-table">
                                <div class="grid6 grid-row-gap-1 px-10 pb-4">
                                    <p class="flex text-grey-600"><img src="/icons/icon-securite-permission.svg" class="size-xs icon-grey mr-2" alt="" /> Permission 1</p>
                                    <p class="flex text-grey-600"><img src="/icons/icon-securite-permission.svg" class="size-xs icon-grey mr-2" alt="" /> Permission 1</p>
                                    <p class="flex text-grey-600"><img src="/icons/icon-securite-permission.svg" class="size-xs icon-grey mr-2" alt="" /> Permission 1</p>
                                    <p class="flex text-grey-600"><img src="/icons/icon-securite-permission.svg" class="size-xs icon-grey mr-2" alt="" /> Permission 1</p>
                                    <p class="flex text-grey-600"><img src="/icons/icon-securite-permission.svg" class="size-xs icon-grey mr-2" alt="" /> Permission 1</p>
                                    <p class="flex text-grey-600"><img src="/icons/icon-securite-permission.svg" class="size-xs icon-grey mr-2" alt="" /> Permission 1</p>
                                    <p class="flex text-grey-600"><img src="/icons/icon-securite-permission.svg" class="size-xs icon-grey mr-2" alt="" /> Permission 1</p>
                                    <p class="flex text-grey-600"><img src="/icons/icon-securite-permission.svg" class="size-xs icon-grey mr-2" alt="" /> Permission 1</p>
                                    <p class="flex text-grey-600"><img src="/icons/icon-securite-permission.svg" class="size-xs icon-grey mr-2" alt="" /> Permission 1</p>
                                    <p class="flex text-grey-600"><img src="/icons/icon-securite-permission.svg" class="size-xs icon-grey mr-2" alt="" /> Permission 1</p>
                                    <p class="flex text-grey-600"><img src="/icons/icon-securite-permission.svg" class="size-xs icon-grey mr-2" alt="" /> Permission 1</p>
                                    <p class="flex text-grey-600"><img src="/icons/icon-securite-permission.svg" class="size-xs icon-grey mr-2" alt="" /> Permission 1</p>
                                </div>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <div class="clear-both h-30"></div>
        </div>

        <confirmation-modal ref="confirmationModalRef"></confirmation-modal>
        <admin-credentials-infos-modal ref="credentialsInfosModalRef"></admin-credentials-infos-modal>
    </section>
  </section>
</template>
